<template>
    <div class="wrapper pb-3">
        <!-- header -->
        <div class="header h-clear" style="position: absolute">
            <b-row no-gutters>
                <b-col cols="auto">
                    <b-button to="/" variant="link" class="text-dark" v-if="$route.path !== '/calculator/guest'">
                        <i class="material-icons">home</i>
                    </b-button>
                </b-col>
                <b-col class="text-center">
                    <img :src="logo" alt="logo-moregiros" class="header-logo py-0">
                </b-col>
                <b-col cols="auto"></b-col>
            </b-row>
        </div>
        <!-- header ends -->

        <transition name="slide" mode="out-in">
            <router-view @loader="hideLoader"></router-view>
        </transition>
    </div>
</template>

<script>
export default {
    name: "AuthComponent",
    data: () => ({
        logo: '/img/logo_header.png',
    }),
    methods: {
        hideLoader() {
            this.$emit('loader');
        }
    }
}
</script>
